import Validasi from './Validasi';
import KirimData from './KirimData';

export const ValidasiConfig = {
    settings: {
        layout: {
            config: {}
        }
    },
    routes  : [
        {
            path     : '/PeringkatPengisian',
            component: Validasi
        }
        ,{
            path     : '/KirimData',
            component: KirimData
        }
    ]
};



// WEBPACK FOOTER //
// ./src/main/content/Validasi/ValidasiConfig.js